// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
    display: flex;
    align-items: center;
    background-color: white;
    border-bottom: 1px solid #E1E9EF;
    height: 80px;
    justify-content: space-between;
    z-index: 3;
    width: 100%;
    position: relative;
}

.header-actions {
    display: flex;
    height: 100%;
    align-items: center;
}

.logo-container {
    margin-left: 110px;
    color: #373D43;
    font-size: 14px;
    font-weight: 700;
}

.login-button {
    border: none;
    padding: 10px 20px;
    cursor: pointer;
    height: 100%;
    margin-right: 92px;
    font-size: 14px;
    display: flex;
    justify-content: center;
    font-weight: 700;
    align-items: center;
}
  
  
.login-button {
    background-color: transparent;
    border-left: 1px solid #E1E9EF;
}

span.login-button-span {
    margin-left: 5px;
}


img.logo {
    width: 40px;
    height: 40px;
}

@media (max-width: 700px) {
    .logo-container {
        margin-left: 5%;
        
    }
}

@media (max-width: 520px) {
    .header{
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Menu/styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;IAChC,YAAY;IACZ,8BAA8B;IAC9B,UAAU;IACV,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;AACvB;;;AAGA;IACI,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI;QACI,eAAe;;IAEnB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":[".header {\n    display: flex;\n    align-items: center;\n    background-color: white;\n    border-bottom: 1px solid #E1E9EF;\n    height: 80px;\n    justify-content: space-between;\n    z-index: 3;\n    width: 100%;\n    position: relative;\n}\n\n.header-actions {\n    display: flex;\n    height: 100%;\n    align-items: center;\n}\n\n.logo-container {\n    margin-left: 110px;\n    color: #373D43;\n    font-size: 14px;\n    font-weight: 700;\n}\n\n.login-button {\n    border: none;\n    padding: 10px 20px;\n    cursor: pointer;\n    height: 100%;\n    margin-right: 92px;\n    font-size: 14px;\n    display: flex;\n    justify-content: center;\n    font-weight: 700;\n    align-items: center;\n}\n  \n  \n.login-button {\n    background-color: transparent;\n    border-left: 1px solid #E1E9EF;\n}\n\nspan.login-button-span {\n    margin-left: 5px;\n}\n\n\nimg.logo {\n    width: 40px;\n    height: 40px;\n}\n\n@media (max-width: 700px) {\n    .logo-container {\n        margin-left: 5%;\n        \n    }\n}\n\n@media (max-width: 520px) {\n    .header{\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
